/** Money display: Israeli style — 1 decimal, thousands `,`, decimal `.` (e.g. 10,342.4). */

export function roundMoney(value: number): number {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  return Math.round(num * 10) / 10;
}

/** Number only (no ₪) — table cells, inputs, CSV. */
export function formatMoneyPlain(amount: number): string {
  const rounded = roundMoney(amount);
  const negative = rounded < 0;
  const [whole, fraction = '0'] = Math.abs(rounded).toFixed(1).split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${negative ? '-' : ''}${grouped}.${fraction}`;
}

export function formatMoney(amount: number): string {
  return `${formatMoneyPlain(amount)}\u00a0₪`;
}

/** Parse typed money: 10,342.4 | 10.342,4 | 10342.4 | 10342 */
export function parseMoneyInput(text: string): number {
  const raw = text.trim().replace(/\s/g, '').replace(/₪/g, '');
  if (!raw || raw === '-' || raw === ',' || raw === '.') return 0;

  const lastComma = raw.lastIndexOf(',');
  const lastDot = raw.lastIndexOf('.');
  let normalized = raw;

  if (lastComma >= 0 && lastDot >= 0) {
    if (lastComma > lastDot) {
      normalized = raw.replace(/\./g, '').replace(',', '.');
    } else {
      normalized = raw.replace(/,/g, '');
    }
  } else if (lastComma >= 0) {
    const decimals = raw.length - lastComma - 1;
    normalized = decimals <= 2 ? raw.replace(',', '.') : raw.replace(/,/g, '');
  } else if (lastDot >= 0) {
    const decimals = raw.length - lastDot - 1;
    if (decimals === 3 && raw.split('.').length > 2) {
      normalized = raw.replace(/\./g, '');
    }
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? roundMoney(parsed) : 0;
}
